export const LocaleIcon = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 10.5C19 12.8869 18.0518 15.1761 16.364 16.864C14.6761 18.5518 12.3869 19.5 10 19.5M19 10.5C19 8.11305 18.0518 5.82387 16.364 4.13604C14.6761 2.44821 12.3869 1.5 10 1.5M19 10.5H1M10 19.5C7.61305 19.5 5.32387 18.5518 3.63604 16.864C1.94821 15.1761 1 12.8869 1 10.5M10 19.5C11.657 19.5 13 15.47 13 10.5C13 5.53 11.657 1.5 10 1.5M10 19.5C8.343 19.5 7 15.47 7 10.5C7 5.53 8.343 1.5 10 1.5M10 1.5C7.61305 1.5 5.32387 2.44821 3.63604 4.13604C1.94821 5.82387 1 8.11305 1 10.5"
      stroke="#1C1327"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
